import {validateTelInputs} from "./utils/validateTelInputs";

validateTelInputs();

$(function() {
    $(".btn-next-form-section").click(function(e) {
        e.preventDefault();

        const currentSection = $(this).closest(".form-section");

        let invalid = false;

        currentSection.find("input[required='required'][type='text']").each(function() {
            if($(this).val().trim() === "") {
                $(this).addClass("is-invalid");
                invalid = true;
            }
        });

        if(invalid) {
            $('html, body').animate({
                scrollTop: $(".is-invalid").offset().top - 100
            }, 500);
            return;
        }

        const target = $(this).data("section");

        //simulate click on tab nav
        $(".nav-link[aria-controls='" + target + "']").click();

        moveToFormNav();
    });

    /**
     * show additional text for "other" option
     * Requires the triggering checkbox to have specified value and note be
     * rendered directly after checkboxes
     */
    $("input[value='jiné'], input[value='jinde'], input[value='kombinované'], input[id=offer_pet_2]").change(function() {
        const parent = $(this).closest("fieldset");
        const input = parent.next().find("input");

        if($(this).is(":checked")) {
            // first invocation changes DOM
            if(input) {
                if(parent.find(".checkbox-columns").length) {
                    parent.append(input);
                } else {
                    parent.find("> div").append(input);
                }
            }

            parent.find("input[type='text']").show().focus();

            parent.find("input[type='text'].required-when-shown").attr("required", true);
        } else {
            parent.find("input[type='text']").removeAttr("required").hide();
        }
    });

    $("input[name='offer[placeType]']").change(function() {
        if ($(this).val() !== "jiné") {
            const parent = $(this).closest("fieldset");

            parent.find("input[type='text']").hide();
        }
    })

    //If we park in garage, parking in snow does not bother us
    $("#offer_parking_0").change(function() {
        if($(this).is(":checked")) {
            $(".offer_snowParking-group").hide();
        } else if($("input[name='offer[usable]']:checked").val() !== "léto") {
            $(".offer_snowParking-group").show();
        }
    })

    //If place is usable only in summer, parking in snow does not bother us
    $("input[name='offer[usable]']").change(function() {
        if($(this).val() === 'léto') {
            $(".offer_snowParking-group").hide();
        } else {
            $(".offer_snowParking-group").show();
        }
    })

    //aboveGroundPoolSize
    $("#offer_recreationalEnjoyment_0").change(function() {
        if($(this).is(":checked")) {
            $(".aboveGroundPoolSize-col").show().find("input").attr("required", true);
        } else {
            $(".aboveGroundPoolSize-col").hide().find("input").removeAttr("required");
        }
    })

    //ingroundPoolSize
    $("#offer_recreationalEnjoyment_1").change(function() {
        if($(this).is(":checked")) {
            $(".ingroundPoolSize-col").show().find("input").attr("required", true);
        } else {
            $(".ingroundPoolSize-col").hide().find("input").removeAttr("required");
        }
    })

    //indoorPoolSize
    $("#offer_recreationalEnjoyment_3").change(function() {
        if($(this).is(":checked")) {
            $(".indoorPoolSize-col").show().find("input").attr("required", true);
        } else {
            $(".indoorPoolSize-col").hide().find("input").removeAttr("required");
        }
    })

    //validation
    $("input[required='required']").blur(function() {
        if($(this).val().trim() === "") {
            $(this).addClass("is-invalid");
        } else {
            $(this).removeClass("is-invalid");
        }
    })
});

function moveToFormNav() {
    $('html, body').animate({
        scrollTop: $(".form-nav").offset().top - 100
    }, 500);
}
